/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : convertUtcToTimeZone.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import moment from "moment";
import "moment-timezone";
import customConsole from "../config/customConsole";

export const convertUtcToTimeZone = (utcTimestamp, timeZone) => {
  if (utcTimestamp) {
    const TZ =
      timeZone && timeZone?.toLowerCase() !== "string"
        ? timeZone
        : "asia/kolkata";
    customConsole(TZ);
    return moment(utcTimestamp)?.tz(TZ)?.format("DD-MM-YYYY hh:mm:ss A");
  } else {
    return "-";
  }
};

export const ConvertUTCToDate = (utcTimestamp, timeZone) => {
  console.log("---timeZone---", timeZone);
  if (utcTimestamp) {
    const TZ =
      timeZone && timeZone?.toLowerCase() !== "string"
        ? timeZone
        : "Asia/Kolkata";
    customConsole(TZ);
    return moment(utcTimestamp).tz(TZ).format("MMM D, YYYY hh:mm A");
  } else {
    return "-";
  }
};
